import { createContext } from 'react';
import type { ConversationMediaContext } from './interfaces';

export const createConversationMediaContextFactory = () =>
  createContext<ConversationMediaContext>({} as any);
